import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductJourneysShow } from '@/features/journeys/Show'

export const Route = createFileRoute('/_event/jornadas/$journeyId/')({
  component: DigitalProductJourneyShowPage
})

function DigitalProductJourneyShowPage() {
  const { journeyId } = Route.useParams()

  return <DigitalProductJourneysShow id={journeyId} />
}
